import React, { createContext, useContext, useState, ReactNode, useCallback } from 'react';

interface NotificationModalContextType {
  openCardModal: (clienteId: string) => void;
  openGestorModal: (feedbackId?: string | null) => void;
  isCardModalOpen: boolean;
  isGestorModalOpen: boolean;
  pendingFeedbackId: string | null;
  selectedClienteId: string | null;
  closeCardModal: () => void;
  closeGestorModal: () => void;
}

const NotificationModalContext = createContext<NotificationModalContextType | undefined>(undefined);

export const useNotificationModal = () => {
  const context = useContext(NotificationModalContext);
  if (!context) {
    throw new Error('useNotificationModal deve ser usado dentro de NotificationModalProvider');
  }
  return context;
};

interface NotificationModalProviderProps {
  children: ReactNode;
}

export const NotificationModalProvider: React.FC<NotificationModalProviderProps> = ({ children }) => {
  const [isCardModalOpen, setIsCardModalOpen] = useState(false);
  const [isGestorModalOpen, setIsGestorModalOpen] = useState(false);
  const [selectedClienteId, setSelectedClienteId] = useState<string | null>(null);
  const [pendingFeedbackId, setPendingFeedbackId] = useState<string | null>(null);

  const openCardModal = useCallback((clienteId: string) => {
    setSelectedClienteId(clienteId);
    setIsCardModalOpen(true);
  }, []);

  const openGestorModal = useCallback((feedbackId?: string | null) => {
    setPendingFeedbackId(feedbackId ?? null);
    setIsGestorModalOpen(true);
  }, []);

  const closeCardModal = useCallback(() => {
    setIsCardModalOpen(false);
    setSelectedClienteId(null);
  }, []);

  const closeGestorModal = useCallback(() => {
    setIsGestorModalOpen(false);
    setPendingFeedbackId(null);
  }, []);

  return (
    <NotificationModalContext.Provider
      value={{
        openCardModal,
        openGestorModal,
        isCardModalOpen,
        isGestorModalOpen,
        pendingFeedbackId,
        selectedClienteId,
        closeCardModal,
        closeGestorModal,
      }}
    >
      {children}
    </NotificationModalContext.Provider>
  );
};
